import axios from 'axios';
import { api, headers } from '../../app/conf';

export const pingEvents = (event_id, token) => axios({
    method: 'get',
    url: `${api}/events/${event_id}`,
    headers: {
        ...headers,
        "X-Access-Token": token,
    }
});

export const fetchFile = (file_name, token) => axios({
    url: `https://gps-administration-api.mavimovil.com/api/files/${file_name}`,
    method: 'GET',
    responseType: 'blob', 
    headers: {
        ...headers,
        "X-Access-Token": token,
    }
}).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${file_name}`);
    document.body.appendChild(link);
    link.click();
    // Limpiar después de la descarga
    setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }, 100);
    return { success: true, fileName: file_name };
}).catch((error) => {

    return { success: false, error };
});